import { TextUrlfy } from '@faceup/ui'
import { ChannelType } from '@faceup/utils'
import { type ReactNode, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { type FragmentType, getFragmentData, graphql } from '../../../__generated__'
import { useCustomValues } from '../../../hooks/useCustomValues'
import { defineMessages } from '../../../TypedIntl'

type ReportChannelType = Exclude<ChannelType, ChannelType.Survey>

const messages = defineMessages<ReportChannelType>({
  [ChannelType.AutomatedHotline]: 'Shared.CompanyReportSent.description',
  [ChannelType.LiveHotline]: 'Shared.CompanyReportSent.description',
  [ChannelType.AiHotline]: 'Shared.CompanyReportSent.description',
  [ChannelType.ReportingSystem]: 'Shared.CompanyReportSent.description',
})

const fragments = {
  useReportSentData_publicReportSource: graphql(`
    fragment useReportSentData_publicReportSource on PublicReportSource {
      id
      sourceType
      config {
        ... on FormReportSourceConfiguration {
          id
          reportSentDescription
        }
      }
    }
  `),
}

export const useReportSentData = (
  _reportSource: FragmentType<typeof fragments.useReportSentData_publicReportSource>
) => {
  const reportSource = getFragmentData(
    fragments.useReportSentData_publicReportSource,
    _reportSource
  )
  const customValues = useCustomValues()
  const config =
    reportSource.config.__typename === 'FormReportSourceConfiguration' ? reportSource.config : null

  const reportSentDescription: ReactNode = useMemo(() => {
    if (customValues?.description) {
      return <TextUrlfy text={customValues.description} />
    }
    if (config?.reportSentDescription) {
      return <TextUrlfy text={config.reportSentDescription} />
    }
    if (reportSource.sourceType === ChannelType.Survey) {
      return null
    }
    return <FormattedMessage {...messages[reportSource.sourceType]} />
  }, [config?.reportSentDescription, reportSource.sourceType, customValues?.description])

  return {
    reportSentDescription,
  }
}
